import { getAuth } from "firebase/auth";
import { initializeApp } from "firebase/app";
import {getFirestore} from '@firebase/firestore'
import { getStorage } from "firebase/storage";


const firebaseConfig = {
    apiKey: "AIzaSyAMhx-N0W7cKX6RsEZmuC3knuQa5yxSQ5w",
    authDomain: "e-voting-system-45287.firebaseapp.com",
    projectId: "e-voting-system-45287",
    storageBucket: "e-voting-system-45287.appspot.com",
    messagingSenderId: "311645595996",
    appId: "1:311645595996:web:4f998581c546ce5a1b7999"
  };

const app = initializeApp(firebaseConfig)
export const firestore = getFirestore(app);
export const firebaseAuth = getAuth(app);
export const storage = getStorage(app);